// Generated with util/create-component.js
import React, { useMemo } from "react";

import { LogoProps } from "./Logo.types";
import horizontal_black from "./svg/horizontal_black.svg";
import horizontal_color_darkbg from "./svg/horizontal_color_darkbg.svg";
import horizontal_color_lightbg from "./svg/horizontal_color_lightbg.svg";
import horizontal_white from "./svg/horizontal_white.svg";
import primary_black from "./svg/primary_black.svg";
import primary_color_darkbg from "./svg/primary_color_darkbg.svg";
import primary_white from "./svg/primary_white.svg";
import tagline_black from "./svg/tagline_black.svg";
import tagline_color_darkbg from "./svg/tagline_color_darkbg.svg";
import tagline_color_lightbg from "./svg/tagline_color_lightbg.svg";
import tagline_white from "./svg/tagline_white.svg";
import styled from "styled-components";

const StyledLogo = styled.img`
object-fit: contain;
`;


const Logo: React.FC<LogoProps> = ({
  size = "md",
  logo = "primary",
  color = "color",
  contrast = "lightbg",
}) => {
  const logos = {
    horizontal: {
      black: {
        darkbg: horizontal_white,
        lightbg: horizontal_black,
      },
      color: {
        darkbg: horizontal_color_darkbg,
        lightbg: horizontal_color_lightbg,
      },
      white: {
        darkbg: horizontal_white,
        lightbg: horizontal_black,
      },
    },
    primary: {
      black: {
        darkbg: primary_white,
        lightbg: primary_black,
      },
      color: {
        darkbg: primary_color_darkbg,
        lightbg: primary_color_darkbg,
      },
      white: {
        darkbg: primary_white,
        lightbg: primary_black,
      },
    },
    tagline: {
      black: {
        darkbg: tagline_white,
        lightbg: tagline_black,
      },
      color: {
        darkbg: tagline_color_darkbg,
        lightbg: tagline_color_lightbg,
      },
      white: {
        darkbg: tagline_white,
        lightbg: tagline_black,
      },
    },
  };

  const height:number | string = useMemo(() => {
    switch(size){
      default:
      case "xxs": return 16;
      case "h6": case "xs": return 24;
      case "h5": case "sm": return 32;
      case "h4": case "md": return 48;
      case "h3": case "lg": return 64;
      case "h2": case "xl": return 128;
      case "h1": case "xxl": return 192;
      case "100%": return "100%";
    }
  }, [ size ]);

  return (
    <StyledLogo
      src={logos[logo][color][contrast]}
      data-testid="Logo"
      style={{ height }}
    />
  );
};

export default Logo;
